


























































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import Toast from '@/app/components/Common/Toast.vue'
import FieldMap from '@/app/components/Field/Map/FieldMap.vue'
import FieldList from '@/app/components/Field/List/FieldList.vue'
import FieldSearch from '@/app/components/Field/FieldSearch.vue'
/* api */
import FieldListApi from '@/app/model/api/fieldListApi'
import FieldDataApi from '@/app/model/api/fieldDataApi'
import FieldDetailsApi from '@/app/model/api/fieldDetailsApi'
/* module */
import CommonClass from '@/app/module/common'
import Local from '@/app/module/local'
import Session from '@/app/module/session'
import { routerPath } from '@/app/model/store/domain/const'

@Component({
  components: {
    CommonHeader,
    Loading,
    Toast,
    FieldMap,
    FieldList,
    FieldSearch
  }
})
export default class FieldBase extends Vue {
  private mapList: Array<{[key:string]: any}> = []
  private fieldList: Array<{[key:string]: any}> = []
  private fieldDetailsData: any[] = []
  public mapData: Array<{[key:string]: any}> = []
  public fieldData: Array<{[key:string]: string|boolean}> = []
  public fieldLength: string='0'
  public areaData: Array<{[key:string]: string}> = []
  public displayAreaData: Array<{[key:string]: string|string[]}> = []
  private showMapLoading: boolean = true
  private accordionLoading: any = {}
  private showFieldListLoading: boolean = true
  private showNotFound: boolean = false
  private showErrorAlert: boolean = false
  private isAccordionActive: boolean = false
  private isActiveClass: boolean = false
  private toastMessage: string = ''
  private isOpend: any = {}
  private accordionFlag: boolean = false
  private scrollFlag: boolean = false
  private isActive: boolean = false
  private sortOrder: string = 'harvestForecastDays'
  private sort: string = 'asc'
  private isChangeSort: boolean = false
  private sortOrderSelected: any = [
    { text: '収穫適期までの日数', value: 'harvestForecastDays' },
    { text: '積算温度', value: 'integrationTemperature' },
    { text: '圃場名', value: 'fieldName' }
  ]
  private sortSelected: any = [
    { text: '昇順', value: 'asc' },
    { text: '降順', value: 'desc' }
  ]
  private isCreated: boolean = false

  private get sortChange (): any {
    return [this.sortOrder, this.sort]
  }

  @Watch('sortChange')
  getSortChange () {
    let search: any = this.$refs.search
    if (search !== undefined && !search.requesting) {
      this.showFieldListLoading = true
      this.isChangeSort = true
      this.changeList(0)
    }
  }

  @Watch('$route')
  changePath (newValue: any) : void {
    if (newValue.name === 'field' && !this.isCreated) {
      this.createdField()
      this.isCreated = true
    }
  }

  private createdField () {
    /* 検索結果を保持しているかどうか判定 */
    let stateData = this.$store.state.fieldState

    // 検索値が全て初期状態だったらlistApiをそのまま叩く処理
    if (stateData.fieldSearchStatus === 0 &&
        stateData.fieldSearchVariety === '' &&
        stateData.fieldSearchGrade === '' &&
        stateData.fieldSearchRisk === 0 &&
        stateData.fieldSearchText === '') {
      this.getFieldData()
    } else {
      this.doSearch()
    }

    this.cacheClear()
  }

  private async getFieldData () {
    this.showMapLoading = true
    this.showFieldListLoading = true
    let search: any = this.$refs.search
    if (search !== undefined) {
      search.requesting = true
    }

    /* ページの一番上を表示 */
    this.isActive = true
    let area: any = document.getElementById('fieldListContainer')!
    if (area !== null) {
      area.scrollTop = 0
    }

    const result = await FieldListApi.getFieldData(this.$store.state.fieldState.plantingOnly)
    this.$store.commit('routeState/setRoute', this.$route.path)

    if (result.isOk()) {
      /* 品種絞り込みのデータ */
      Local.setVarietiesData(JSON.stringify(result.getPayload().varieties))
      Local.setGradeData(JSON.stringify(result.getPayload().grade))
      Local.setGrowthStageData(JSON.stringify(result.getPayload().growth_stage))

      /* データ追加フラグ更新 */
      this.$store.commit('setFlagState/setSelectDataListFlag', true)

      /* マップのデータを作成 */
      if (result.getPayload().area.length !== 0) {
        this.areaData = result.getPayload().area
        this.displayAreaData = []

        /* アコーディオン押下時、並び替え前の一覧が表示されてしまわないよう圃場を空にする */
        for (let k in this.areaData) {
          this.displayAreaData.push({
            area_id: this.areaData[k].area_id,
            district_code: this.areaData[k].district_code,
            district_name: this.areaData[k].district_name,
            total_field_count: this.areaData[k].total_field_count,
            field_length: String(this.areaData[k].field.length),
            field: []
          })
        }

        // リセット
        this.mapList = []
        this.fieldList = []

        /* マップデータ作成 */
        for (var j in result.getPayload().area) {
          this.createDataList(result.getPayload().area[j].field, result.getPayload().area[j].area_id)

          /* エリアデータをlocalstorageに保存 */
          let areaData = result.getPayload().area[j]
          areaData['timestamp'] = Date.now()

          /* エリアごとに詳細を取得 */
          this.showFieldListLoading = false
        }
        this.$store.commit('mapState/setMapList', this.mapList)
        this.mapData = this.$store.state.mapState.mapData
        /* fieldList */
        this.$store.commit('fieldState/setFieldData', this.fieldList)
        this.fieldData = this.$store.state.fieldState.fieldData
        Session.setFieldData(JSON.stringify(this.fieldData))
        this.fieldLength = String(this.fieldList.length)
        this.mapCreate()

        this.showMapLoading = false
        this.isActive = false

        if (search !== undefined) {
          search.requesting = false
        }
      } else {
        // 作付けデータ無しの場合
        this.mapList = []
        this.areaData = []
        this.displayAreaData = []
        this.showNotFound = true
        this.fieldLength = '0'
        this.mapCreate()

        this.showMapLoading = false
        this.showFieldListLoading = false
        this.isActive = false

        if (search !== undefined) {
          search.requesting = false
        }
      }
    } else if (result.checkTimeoutErrorStatus()) {
      this.$store.commit('routeState/setTimeoutErrorFlag', true)
      this.$store.commit('routeState/setErrorFlag', false)
      this.$router.push(routerPath.PATH_ERROR_PAGE)
    } else if (result.checkErrorStatus()) {
      this.$store.commit('routeState/setErrorFlag', true)
      this.$router.push(routerPath.PATH_ERROR_PAGE)
    } else if (result.checkNotFoundStatus()) {
      this.$store.commit('routeState/setErrorFlag', false)
      this.$router.push(routerPath.PATH_ERROR_PAGE)
    } else if (result.checkStatus()) {
      CommonClass.doLogout()
    } else {
      this.toastMessage = result.getPayload().message
      this.showErrorAlert = true
    }
  }

  private getFieldDetailsData (id: number, flag: boolean) : any {
    (async () => {
      if (id !== 0 && id !== undefined) {
        if (Session.getFieldDetailsData(String(id))! === null) {
          this.$set(this.accordionLoading, id, true)
          let searchItem = {
            refile: this.$store.state.fieldState.plantingOnly,
            status: this.$store.state.fieldState.fieldSearchStatus,
            variety: this.$store.state.fieldState.fieldSearchVariety,
            grade: this.$store.state.fieldState.fieldSearchGrade,
            risk: this.$store.state.fieldState.fieldSearchRisk,
            word: this.$store.state.fieldState.fieldSearchText
          }
          const result = await FieldDetailsApi.getFieldDetailsData(String(id), flag, 1, searchItem, [])
          if (result.isOk()) {
            if (result.getPayload() === null) {
              return
            }

            this.fieldDetailsData.push(result.getPayload())
            result.getPayload().unshift({ timestamp: Date.now() })

            // 並び替え用にデータをセット
            let changeId = ''
            for (let i in this.areaData) {
              changeId = String(id)
              if (parseInt(this.areaData[i].area_id) === id) {
                let data: any = this.areaData[i].field
                for (let l in data) {
                  for (let j in result.getPayload()) {
                    if (data[l].planting.planting_id === result.getPayload()[j].planting_id) {
                      data[l].intergration_temperature = result.getPayload()[j].intergration_temperature
                      data[l].harvest_forecast_days = result.getPayload()[j].harvest_forecast_days
                      break
                    }
                  }
                }
                this.areaData[i].field = data
              }
            }
            this.changeList(parseInt(changeId))

            Session.setFieldDetailsData(JSON.stringify(result.getPayload()), String(id))

            /* データ取得フラグ */
            this.$store.commit('setFlagState/setFieldDetailsDataFlag', true)
          } else if (result.checkTimeoutErrorStatus()) {
            this.$store.commit('routeState/setTimeoutErrorFlag', true)
            this.$store.commit('routeState/setErrorFlag', false)
            this.$router.push(routerPath.PATH_ERROR_PAGE)
          } else if (result.checkErrorStatus()) {
            this.$store.commit('routeState/setErrorFlag', true)
            this.$router.push(routerPath.PATH_ERROR_PAGE)
          } else if (result.checkNotFoundStatus()) {
            this.$store.commit('routeState/setErrorFlag', false)
            this.$router.push(routerPath.PATH_ERROR_PAGE)
          } else if (result.checkStatus()) {
            CommonClass.doLogout()
          } else {
            this.toastMessage = result.getPayload().message
            this.showErrorAlert = true
          }
        } else {
          // 並び替え用にデータをセット
          let changeId = ''
          for (let i in this.areaData) {
            changeId = String(id)
            if (parseInt(this.areaData[i].area_id) === id) {
              let data: any = this.areaData[i].field
              for (let l in data) {
                if (data[l].planting.planting_id !== 0 && data[l].intergration_temperature === undefined) {
                  const detailData: any = Session.getFieldDetailsData(String(id))
                  for (let j in JSON.parse(detailData)) {
                    if (data[l].planting.planting_id === JSON.parse(detailData)[j].planting_id) {
                      data[l].intergration_temperature = JSON.parse(detailData)[j].intergration_temperature
                      data[l].harvest_forecast_days = JSON.parse(detailData)[j].harvest_forecast_days
                      break
                    }
                  }
                  this.areaData[i].field = data
                }
              }
            }
          }
          this.changeList(parseInt(changeId))

          /* データ取得フラグ */
          this.$store.commit('setFlagState/setFieldDetailsDataFlag', true)
        }
        this.$set(this.accordionLoading, id, false)
      }
    })()
  }

  /* 詳細データ(localStorage)のキャッシュをクリア */
  private async cacheClear () {
    await Session.clearDetailsCache()
  }

  private createDataList (result: any, areaId: number) {
    let mapList = []
    /* マップのデータを作成 */
    for (var i in result) {
      const mapData: any = {
        id: result[i].id,
        path: result[i].polygon,
        strokeColor: result[i].polygon_color,
        fillColor: result[i].polygon_color,
        sensorPosition: result[i].sensor,
        cameraSensorPosition: result[i].camera_sensor,
        plantingList: result[i].planting
      }

      const fieldData: any = {
        areaId: areaId,
        fieldName: result[i].planting.field_name,
        gradeName: result[i].planting.grade_name,
        plantingId: result[i].planting.planting_id,
        fieldId: result[i].id,
        workerName: result[i].planting.worker_name
      }

      if (result[i].polygon.length === 0) {
        mapData.fieldPosition = {
          lat: parseFloat(result[i].field_lat),
          lng: parseFloat(result[i].field_lng)
        }
      }

      this.mapList.push(mapData)
      this.fieldList.push(fieldData)
    }
  }

  private mapCreate () {
    if (this.mapList.length !== 0) {
      /* リストの一番上のデータをマップの中心にする */
      if (Object.keys(this.mapList[0].path).length !== 0) {
        if (this.$store.state.mapState.basicData.position.lng === this.mapList[0].path[0].lng) {
          this.$store.commit('mapState/setBaseData', this.mapList[0].path[1])
        } else {
          this.$store.commit('mapState/setBaseData', this.mapList[0].path[0])
        }
      } else {
        this.$store.commit('mapState/setBaseData', this.mapList[0].fieldPosition)
      }
    }
  }

  /* 検索 */
  private async doSearch () {
    let search: any = this.$refs.search
    if (search !== undefined) {
      search.requesting = true
    }

    this.showFieldListLoading = true
    this.isActive = true
    let area: any = document.getElementById('fieldListContainer')!
    if (area !== null) {
      area.scrollTop = 0
    }
    Session.setChoiceFieldId('')
    this.$store.commit('fieldChoiceState/setChoosingFieldId', '')

    /* アコーディオンを一度すべて閉じる */
    for (var i in this.areaData) {
      const id = this.areaData[i].area_id
      this.$set(this.isOpend, parseInt(id), false)
    }

    let searchItem = {
      refile: this.$store.state.fieldState.plantingOnly,
      status: this.$store.state.fieldState.fieldSearchStatus,
      variety: this.$store.state.fieldState.fieldSearchVariety,
      grade: this.$store.state.fieldState.fieldSearchGrade,
      risk: this.$store.state.fieldState.fieldSearchRisk,
      word: this.$store.state.fieldState.fieldSearchText
    }

    const result = await FieldDataApi.getFieldData(1, searchItem, [])

    if (result.isOk()) {
      /* マップのデータを作成 */
      if (result.getPayload().area.length !== 0) {
        this.areaData = result.getPayload().area
        this.displayAreaData = []

        /* アコーディオン押下時、並び替え前の一覧が表示されてしまわないよう圃場を空にする */
        for (let k in this.areaData) {
          this.displayAreaData.push({
            area_id: this.areaData[k].area_id,
            district_code: this.areaData[k].district_code,
            district_name: this.areaData[k].district_name,
            total_field_count: this.areaData[k].total_field_count,
            field_length: String(this.areaData[k].field.length),
            field: []
          })
        }

        // リセット
        this.mapList = []
        this.fieldList = []

        /* マップデータ作成 */
        for (var j in result.getPayload().area) {
          this.createDataList(result.getPayload().area[j].field, result.getPayload().area[j].area_id)

          /* エリアデータをlocalstorageに保存 */
          let areaData = result.getPayload().area[j]
          areaData['timestamp'] = Date.now()
        }
        this.fieldLength = String(this.fieldList.length)
        this.$store.commit('mapState/setMapList', this.mapList)
        this.mapData = this.$store.state.mapState.mapData
        /* fieldList */
        this.$store.commit('fieldState/setFieldData', this.fieldList)
        this.fieldData = this.$store.state.fieldState.fieldData
        Session.setFieldData(JSON.stringify(this.fieldData))
        this.showNotFound = false
      } else {
        this.mapList = []
        this.areaData = []
        this.displayAreaData = []
        this.showNotFound = true
        this.fieldLength = '0'
        this.showFieldListLoading = false
      }
      this.showMapLoading = false
      this.showFieldListLoading = false
      this.isActive = false
      search.requesting = false
    } else if (result.checkTimeoutErrorStatus()) {
      this.$store.commit('routeState/setTimeoutErrorFlag', true)
      this.$store.commit('routeState/setErrorFlag', false)
      this.$router.push(routerPath.PATH_ERROR_PAGE)
    } else if (result.checkErrorStatus()) {
      this.$store.commit('routeState/setErrorFlag', true)
      this.$router.push(routerPath.PATH_ERROR_PAGE)
    } else if (result.checkNotFoundStatus()) {
      this.$store.commit('routeState/setErrorFlag', false)
      this.$router.push(routerPath.PATH_ERROR_PAGE)
    } else if (result.checkStatus()) {
      CommonClass.doLogout()
    } else {
      // 作付けデータ無しの場合
      this.mapList = []
      this.areaData = []
      this.displayAreaData = []
      this.showNotFound = true
      this.fieldLength = '0'

      this.showMapLoading = false
      this.showFieldListLoading = false
      this.isActive = false
      search.requesting = false
    }
  }

  /* 圃場の絞り込みをリセット（初期値に戻す） */
  private resetFieldList () {
    if (this.showNotFound) {
      this.showNotFound = false
    }

    this.showFieldListLoading = true
    /* アコーディオンを一度すべて閉じる */
    for (var i in this.areaData) {
      const id = this.areaData[i].area_id
      this.$set(this.isOpend, parseInt(id), false)
    }
    this.sortOrder = 'harvestForecastDays'
    this.sort = 'asc'
    Session.setChoiceFieldId('')
    this.$store.commit('fieldChoiceState/setChoosingFieldId', '')

    this.getFieldData()
  }

  private closeAlert () {
    this.showErrorAlert = false
  }

  /* アコーディオン */
  private isOpenedAccordion (key: number) {
    if (!this.accordionLoading[key]) {
      this.getFieldDetailsData(key, true)
      this.scrollFlag = true
      this.$set(this.isOpend, key, !this.isOpend[key])
    }
  }

  private scrollIntoViewFlag: boolean = false
  private oepnSpecificAccordion (areaId: string) {
    let key = parseInt(areaId)
    if (!this.isOpend[key] && !this.accordionLoading[key]) {
      this.scrollIntoViewFlag = true
      this.getFieldDetailsData(key, true)
      this.$set(this.isOpend, key, true)
    }
  }

  private afterTransition () {
    if (this.scrollIntoViewFlag) {
      let id = Session.getChoiceFieldId()
      let el: any = document.getElementById(String(id))
      if (el) {
        el.scrollIntoView({ behavior: 'instant' })
      }
      this.scrollIntoViewFlag = false
    }
  }

  // 一覧並び替え
  private changeList (id: number) {
    /* ページの一番上を表示 */
    let area: any = document.getElementById('fieldListContainer')!
    if (area !== null && this.isChangeSort) {
      area.scrollTop = 0
    }
    let newList: any = this.areaData
    for (let i in newList) {
      if ((id === 0 && this.displayAreaData[parseInt(i)].field.length !== 0) || newList[i].area_id === id) {
        if (this.sortOrder === 'fieldName') {
          if (this.sort === 'asc') {
            newList[i].field.sort(
              function (a: any, b: any) {
                if (a.planting.field_name !== b.planting.field_name) {
                  return (a.planting.field_name < b.planting.field_name ? -1 : 1)
                }
                return 0
              }
            )
          } else {
            newList[i].field.sort(
              function (a: any, b: any) {
                if (a.planting.field_name !== b.planting.field_name) {
                  return (a.planting.field_name < b.planting.field_name ? 1 : -1)
                }
                return 0
              }
            )
          }
        } else if (this.sortOrder === 'harvestForecastDays') {
          if (this.sort === 'asc') {
            newList[i].field.sort(
              function (a: any, b: any) {
                // 収穫適期の残日数が無かったら0を代入
                if (a.harvest_forecast_days === undefined) {
                  a.harvest_forecast_days = -1
                }
                if (b.harvest_forecast_days === undefined) {
                  b.harvest_forecast_days = -1
                }

                if (a.harvest_forecast_days !== b.harvest_forecast_days) {
                  return (a.harvest_forecast_days < b.harvest_forecast_days ? -1 : 1)
                }
                if (a.planting.field_name !== b.planting.field_name) {
                  return (a.planting.field_name < b.planting.field_name ? -1 : 1)
                }
                return 0
              }
            )
          } else {
            newList[i].field.sort(
              function (a: any, b: any) {
                // 収穫適期の残日数が無かったら0を代入
                if (a.harvest_forecast_days === undefined) {
                  a.harvest_forecast_days = -1
                }
                if (b.harvest_forecast_days === undefined) {
                  b.harvest_forecast_days = -1
                }

                if (a.harvest_forecast_days !== b.harvest_forecast_days) {
                  return (a.harvest_forecast_days < b.harvest_forecast_days ? 1 : -1)
                }
                if (a.planting.field_name !== b.planting.field_name) {
                  return (a.planting.field_name < b.planting.field_name ? -1 : 1)
                }
                return 0
              }
            )
          }
        } else {
          if (this.sort === 'asc') {
            newList[i].field.sort(
              function (a: any, b: any) {
                // 積算温度が無かったら0を代入
                if (a.intergration_temperature === undefined) {
                  a.intergration_temperature = -1
                }
                if (b.intergration_temperature === undefined) {
                  b.intergration_temperature = -1
                }

                if (a.intergration_temperature !== b.intergration_temperature) {
                  return (a.intergration_temperature < b.intergration_temperature ? -1 : 1)
                }
                if (a.planting.field_name !== b.planting.field_name) {
                  return (a.planting.field_name < b.planting.field_name ? -1 : 1)
                }
                return 0
              }
            )
          } else {
            newList[i].field.sort(
              function (a: any, b: any) {
                // 積算温度が無かったら0を代入
                if (a.intergration_temperature === undefined) {
                  a.intergration_temperature = -1
                }
                if (b.intergration_temperature === undefined) {
                  b.intergration_temperature = -1
                }

                if (a.intergration_temperature !== b.intergration_temperature) {
                  return (a.intergration_temperature < b.intergration_temperature ? 1 : -1)
                }
                if (a.planting.field_name !== b.planting.field_name) {
                  return (a.planting.field_name < b.planting.field_name ? -1 : 1)
                }
                return 0
              }
            )
          }
        }
        for (let j in this.areaData) {
          if (parseInt(this.areaData[j].area_id) === id) {
            this.areaData[j] = newList[i]
          }
        }
        this.displayAreaData[parseInt(i)].field = newList[i].field
      }
    }
    this.isChangeSort = false
    this.showFieldListLoading = false
  }
}
